// LimitText Class
import { LimitText } from "../classes/LimitText";

// Moment js for dates and datepicker
import * as moment from 'moment/moment';
import "daterangepicker/daterangepicker";

const cardsParagraph = document.querySelectorAll(".events-cards .card p.card-text");

function replaceNbsps(str) {
    var re = new RegExp(String.fromCharCode(10), "g");
    return str.trim().replace(re, "<br>");
}

cardsParagraph.forEach( (paragraph) => {
    let limit = 300;
    let inputText = paragraph.innerHTML;
    if ( inputText.length > limit ) {
        let limit_Text_size = new LimitText(inputText, limit);
        paragraph.innerHTML = limit_Text_size.limitOutput;
    }
    paragraph.innerHTML = replaceNbsps(paragraph.innerHTML);
});

const events_list = document.querySelectorAll('#event-cards .event');
const events_timeline_menu = $('#events-timeline');

const order_dd_menu = $('#events .sortby').find('.dropdown-menu');
const order_dd_toggler = $('#events .sortby').find('.dropdown-toggle');

// Show active order switch case (UMBRACO)
function eventActiveOrder(activeOrder){
    switch(activeOrder){
        case '#ascending':
            $('#events .eventsListAsc').addClass('active');
            $('#events .eventsListAsc .event').addClass('active');
            break;
        case '#descending':
            $('#events .eventsListDesc').addClass('active');
            $('#events .eventsListDesc .event').addClass('active');
            break;
        default:
            $('#events .eventsListAsc').addClass('active');
            $('#events .eventsListAsc .event').addClass('active');
            break;
    }
}

// Show only active events on period change
function eventActivateTimeperiod(activePeriod) {
    if(activePeriod !== 'all'){
        $('#events .eventsList.active .event.active').hide();
        document.querySelectorAll('#events .eventsList.active .event.active').forEach((event) => {
            if($(event).attr('data-period') === activePeriod ) {
                $(event).show();
            }
            if($(event).attr('data-year') === activePeriod ) {
                $(event).show();
            }
        });
    } else {
        $('#events .eventsList.active .event.active').show();
    }
    
}

// Change Arabic months to English
function changeMonthArabic(inputDate){
    const inputDateArray = inputDate.split(' ');
    switch(inputDateArray[1]){
        case 'يناير':
            inputDateArray[1] = 'January';
            break;
        case 'فبراير':
            inputDateArray[1] = 'February';
            break;
        case 'مارس':
            inputDateArray[1] = 'March';
            break;
        case 'أبريل':
            inputDateArray[1] = 'April';
            break;
        case 'مايو':
            inputDateArray[1] = 'May';
            break;
        case 'يونيو':
            inputDateArray[1] = 'June';
            break;
        case 'يوليه':
            inputDateArray[1] = 'July';
            break;
        case 'أغسطس':
            inputDateArray[1] = 'August';
            break;
        case 'سبتمبر':
            inputDateArray[1] = 'September';
            break;
        case 'أكتوبر':
            inputDateArray[1] = 'October';
            break;
        case 'نوفمبر':
            inputDateArray[1] = 'November';
            break;
        case 'ديسمبر':
            inputDateArray[1] = 'December';
            break;
        default:
            break;
    }
    return `${inputDateArray[0]} ${inputDateArray[1]} ${inputDateArray[2]}`;
}

// Change English months to Arabic
function changeMonthEnglish(inputDate){
    const inputDateArray = inputDate.split(' ');
    switch(inputDateArray[1].toLowerCase()){
        case 'january':
            inputDateArray[1] = 'يناير';
            break;
        case 'february':
            inputDateArray[1] = 'فبراير';
            break;
        case 'march':
            inputDateArray[1] = 'مارس';
            break;
        case 'april':
            inputDateArray[1] = 'أبريل';
            break;
        case 'may':
            inputDateArray[1] = 'مايو';
            break;
        case 'june':
            inputDateArray[1] = 'يونيو';
            break;
        case 'july':
            inputDateArray[1] = 'يوليه';
            break;
        case 'august':
            inputDateArray[1] = 'أغسطس';
            break;
        case 'september':
            inputDateArray[1] = 'سبتمبر';
            break;
        case 'october':
            inputDateArray[1] = 'أكتوبر';
            break;
        case 'november':
            inputDateArray[1] = 'نوفمبر';
            break;
        case 'december':
            inputDateArray[1] = 'ديسمبر';
            break;
        default:
            break;
    }
    return `${inputDateArray[0]} ${inputDateArray[1]} ${inputDateArray[2]}`;
}

$(function(){

    // ON PAGE LOAD EVENT
    const culture = document.documentElement.lang.substr(0,2);
    if(culture === 'en'){
        // english 
        if($('input[name="daterange"]').length > 0){
            const eventsDatesArr = []; 
            for(let i=0; i < $('.eventsList .event').length; i++){
                const eventDate = $('.eventsList .event').eq(i).attr('data-date');
                eventsDatesArr.push(new Date(eventDate.toString()));
            };
            const maxDate = new Date(Math.max.apply(null, eventsDatesArr));
            const minDate = new Date(Math.min.apply(null, eventsDatesArr));
            // //console.log(minDate, maxDate);
            
            // Initialize date range picker
            $('input[name="daterange"]').daterangepicker({
                "showDropdowns": true,
                "maxYear": new Date().getFullYear,
                "autoApply": true,
                "maxSpan": false,
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                },
                "locale": {
                    "format": "DD MMMM YYYY",
                    "separator": " - ",
                    "applyLabel": "Apply",
                    "cancelLabel": "Cancel",
                    "fromLabel": "From",
                    "toLabel": "To",
                    "customRangeLabel": "Custom",
                    "weekLabel": "W",
                    "daysOfWeek": [
                        "Sa",
                        "Su",
                        "Mo",
                        "Tu",
                        "We",
                        "Th",
                        "Fr",
                    ],
                    "monthNames": [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    "firstDay": 1
                },
                "startDate": moment(minDate).format('DD MMMM YYYY'),
                "endDate": moment(maxDate).format('DD MMMM YYYY'),
                "maxDate": false,
                "opens": "center",
                "drops": "auto"
            }, function(start, end, label) {
            //console.log('New date range selected: ' + start.format('DD MMMM YYYY') + ' to ' + end.format('DD MMMM YYYY') + ' (predefined range: ' + label + ')');
            });
    
            // On applying Date Range
            $('input[name="daterange"]').on('apply.daterangepicker', function(ev, picker) {
                const startDate = picker.startDate.format('DD MMMM YYYY');
                const endDate = picker.endDate.format('DD MMMM YYYY');
                // //console.log(startDate, endDate);
                for(let i=0; i < $('.eventsList .event').length; i++){
                    const eventDate = $('.eventsList .event').eq(i).attr('data-date');
                    // //console.log(new Date(startDate.toString()), new Date(eventDate.toString()), new Date(endDate.toString()));
                    if( (new Date(startDate.toString()) <= new Date(eventDate.toString())) && (new Date(eventDate.toString()) <= new Date(endDate.toString())) ){
                        $('.eventsList .event').eq(i).show().addClass('active');
                    }else{
                        $('.eventsList .event').eq(i).hide().addClass('inactive');
                    }
                };
            });
        }
    }else{
        // arabic
        if($('input[name="daterange"]').length > 0){
            const eventsDatesArr = []; 
            for(let i=0; i < $('.eventsList .event').length; i++){
                let eventDate = $('.eventsList .event').eq(i).attr('data-date');
                eventDate = changeMonthArabic(eventDate);
                // //console.log(eventDate);

                eventsDatesArr.push(new Date(eventDate.toString()));
            };
            const maxDate = new Date(Math.max.apply(null, eventsDatesArr));
            const minDate = new Date(Math.min.apply(null, eventsDatesArr));
            // //console.log(minDate, maxDate);
            // //console.log(eventsDatesArr);

            
            // Initialize date range picker
            $('input[name="daterange"]').daterangepicker({
                "showDropdowns": true,
                "maxYear": new Date().getFullYear,
                "autoApply": true,
                "maxSpan": false,
                "rtl": true,
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                },
                "locale": {
                    "format": "DD MMMM YYYY",
                    "separator": " - ",
                    "applyLabel": "Apply",
                    "cancelLabel": "Cancel",
                    "fromLabel": "From",
                    "toLabel": "To",
                    "customRangeLabel": "Custom",
                    "weekLabel": "W",
                    "daysOfWeek": [
                        "سبت",
                        "أحد",
                        "اثنين",
                        "ثلاثاء",
                        "اربعاء",
                        "خميس",
                        "جمعة",
                    ],
                    "monthNames": [
                        "يناير",
                        "فبراير",
                        "مارس",
                        "إبريل",
                        "مايو",
                        "يونيو",
                        "يوليو",
                        "أغسطس",
                        "سبتمبر",
                        "أكتوبر",
                        "نوفمبر",
                        "ديسمبر"
                    ],
                    "firstDay": 1
                },
                "startDate": moment(minDate).format('DD MMMM YYYY'),
                "endDate": moment(maxDate).format('DD MMMM YYYY'),
                "maxDate": false,
                "opens": "center",
                "drops": "auto"
            }, function(start, end, label) {
                //console.log('New date range selected: ' + start.format('DD MMMM YYYY') + ' to ' + end.format('DD MMMM YYYY') + ' (predefined range: ' + label + ')');
                // const startDate = changeMonthEnglish(start.format('DD MMMM YYYY'));
                // const endDate = changeMonthEnglish(end.format('DD MMMM YYYY'));
                // $('input[name="daterange"]').val(`${startDate} - ${endDate}`);
            });
            const dateRangeArr = $('input[name="daterange"]').val().toString().split('-');
            const startDate = changeMonthEnglish(dateRangeArr[0].toString().trim());
            const endDate = changeMonthEnglish(dateRangeArr[1].toString().trim());
            $('input[name="daterange"]').val(`${startDate} - ${endDate}`);
    
            // On applying Date Range
            $('input[name="daterange"]').on('apply.daterangepicker', function(ev, picker) {
                let startDate = picker.startDate.format('DD MMMM YYYY');
                let endDate = picker.endDate.format('DD MMMM YYYY');
                startDate = changeMonthArabic(startDate);
                endDate = changeMonthArabic(endDate);
                
                // //console.log(startDate, endDate);
                for(let i=0; i < $('.eventsList .event').length; i++){
                    const eventDate = $('.eventsList .event').eq(i).attr('data-date');
                    eventDate = changeMonthArabic(eventDate);
                    // //console.log(new Date(startDate.toString()), new Date(eventDate.toString()), new Date(endDate.toString()));
                    if( (new Date(startDate.toString()) <= new Date(eventDate.toString())) && (new Date(eventDate.toString()) <= new Date(endDate.toString())) ){
                        $('.eventsList .event').eq(i).show().addClass('active');
                    }else{
                        $('.eventsList .event').eq(i).hide().addClass('inactive');
                    }
                };

                startDate = changeMonthEnglish(startDate);
                endDate = changeMonthEnglish(endDate);
                $('input[name="daterange"]').val(`${startDate} - ${endDate}`);
            });
            // On hiding datepicker
            $('input[name="daterange"]').on('hide.daterangepicker', function(ev, picker) {
                let startDate = picker.startDate.format('DD MMMM YYYY');
                let endDate = picker.endDate.format('DD MMMM YYYY');
                startDate = changeMonthArabic(startDate);
                endDate = changeMonthArabic(endDate);
                // //console.log(startDate, endDate);
                for(let i=0; i < $('.eventsList .event').length; i++){
                    const eventDate = $('.eventsList .event').eq(i).attr('data-date');
                    eventDate = changeMonthArabic(eventDate);
                    // //console.log(new Date(startDate.toString()), new Date(eventDate.toString()), new Date(endDate.toString()));
                    if( (new Date(startDate.toString()) <= new Date(eventDate.toString())) && (new Date(eventDate.toString()) <= new Date(endDate.toString())) ){
                        $('.eventsList .event').eq(i).show().addClass('active');
                    }else{
                        $('.eventsList .event').eq(i).hide().addClass('inactive');
                    }
                };

                startDate = changeMonthEnglish(startDate);
                endDate = changeMonthEnglish(endDate);
                $('input[name="daterange"]').val(`${startDate} - ${endDate}`);
            });
        }

    }
    


    // // Hide all events list THEN show only the correct order according to item 'events-order'
    // $('#events .eventsList').removeClass('active');

    // Clear order active selection
    order_dd_menu.find('.dropdown-item').removeClass('active');

    // Check for session storage item (events-order) value
    // If not found activate the first choice
    // Else activate the found item 'events-order' value
    if(sessionStorage.getItem('events-order') === null){
        // Activate the default order
        order_dd_menu.find('li').eq(0).find('.dropdown-item').addClass('active');
        order_dd_toggler.text(order_dd_menu.find('li').eq(0).find('.dropdown-item').text());
        // Set item to default order value
        sessionStorage.setItem('events-order', order_dd_menu.find('li').eq(0).find('.dropdown-item').attr('href'));
    }else{
        // loop over order dropdown items
        for( let i=0; i < order_dd_menu.find('li').length; i++ ){
            // Compare to item 'events-order'
            if(order_dd_menu.find('li').eq(i).find('.dropdown-item').attr('href') === sessionStorage.getItem('events-order')){
                // Activate the corresponding dropdown item
                order_dd_menu.find('li').eq(i).find('.dropdown-item').addClass('active');
                order_dd_toggler.text(order_dd_menu.find('li').eq(i).find('.dropdown-item').text());
            }
        }
    }

    // Sort according to session storage
    let orderBy = sessionStorage.getItem('events-order');
    eventActiveOrder(orderBy);


    // EVENT HANDLER
    // Change order selection
    order_dd_menu.find('.dropdown-item').on('click', (e) => {
        e.preventDefault();

        const selected_item = $(e.currentTarget);
        order_dd_menu.find('.dropdown-item').removeClass('active');
        selected_item.addClass('active');
        order_dd_toggler.text(selected_item.text());

        sessionStorage.setItem('events-order', selected_item.attr('href').toLowerCase());
        $('#events .eventsList').removeClass('active');
        // Show only active order
        orderBy = sessionStorage.getItem('events-order');
        eventActiveOrder(orderBy);

        eventActivateTimeperiod(
            events_timeline_menu.find('div a.active').attr('href').substring(1)
        );
    });


    // EVENT HANDLER
    // Change timeline selection
    events_timeline_menu.find('div a').on('click', (e) => {
        e.preventDefault();

        const selected_period = $(e.currentTarget);
        const selected_period_target = $(e.currentTarget).attr('href').substring(1);
        events_timeline_menu.find('div a').removeClass('active');
        selected_period.addClass('active');

        // Show only active order
        orderBy = sessionStorage.getItem('events-order');
        eventActiveOrder(orderBy);

        eventActivateTimeperiod(
            selected_period_target
        );

    });
    
});